/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GrowthLegend from './growth-legend';
import GrowthLegendDetail from './growth-legend-detail';
import GrowthLegendUpdate from './growth-legend-update';
import GrowthLegendDeleteDialog from './growth-legend-delete-dialog';

const GrowthLegendRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GrowthLegend />} />
    <Route path="new" element={<GrowthLegendUpdate />} />
    <Route path=":id">
      <Route index element={<GrowthLegendDetail />} />
      <Route path="edit" element={<GrowthLegendUpdate />} />
      <Route path="delete" element={<GrowthLegendDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GrowthLegendRoutes;
